
import {
    Prop,
    Component,
    Vue
} from "vue-property-decorator";
import {
    Doughnut,
    mixins
} from "vue-chartjs";

@Component({
    extends: Doughnut
})
export default class DoughnutCharBase extends Vue {
    @Prop(Object) chartData!: Object;
    @Prop(Object) options!: Object;

    mounted() {
        (this as any).renderChart(this.chartData, this.options, {
            borderWidth: "10px",
            hoverBackgroundColor: "red",
            hoverBorderWidth: "10px",
            tooltips: {
                enabled: false
            }
        });
    }
}
